// index.js
import en from './en.json'
import la from './la.json'

export const defaultLocale = 'la'

export const languages = {
  en: en,
  la: la,
}